import { routeAccess } from 'app/access';
import RequireAuth from 'app/components/RequireAuth';
import { lazy } from 'react';
import { Route } from 'react-router';

// Lazy load all admin-related routes
const AccountingMonthsRoute = lazy(() => import('./accounting-months/AccountingMonthsRoute'));
const AccountingMonthCreateRoute = lazy(() => import('./accounting-months/AccountingMonthCreateRoute'));
const AccountingMonthDetailsRoute = lazy(() => import('./accounting-months/AccountingMonthDetailsRoute'));
const RefererRoute = lazy(() => import('./referer/RefererRoute'));
const CreateRefRoute = lazy(() => import('./referer/CreateRefRoute'));
const RefRoute = lazy(() => import('./referer/RefRoute'));
const AuditLogsRoute = lazy(() => import('./audit-logs/AuditLogsRoute'));
const AuditLogRoute = lazy(() => import('./audit-logs/AuditLogRoute'));
const ChartOfAccountsCreateRoute = lazy(() => import('./charts-of-accounts/ChartOfAccountsCreateRoute'));
const ChartsOfAccountsRoute = lazy(() => import('./charts-of-accounts/ChartsOfAccountsRoute'));
const ChartOfAccountsDetailsRoute = lazy(() => import('./charts-of-accounts/ChartOfAccountsDetailsRoute'));
const PartnerRoute = lazy(() => import('./partners/PartnerRoute'));
const PartnersRoute = lazy(() => import('./partners/PartnersRoute'));
const PartnerCreateRoute = lazy(() => import('./partners/CreatePartnerRoute'));
const OperatingMessagesRoute = lazy(() => import('./operating-messages/OperatingMessagesRoute'));
const OperatingMessageDetailsRoute = lazy(() => import('./operating-messages/OperatingMessageDetailsRoute'));
const OperatingMessageCreateRoute = lazy(() => import('./operating-messages/OperatingMessageCreateRoute'));

import TransactionTypesRoute from './transaction-types/TransactionTypesRoute';
import TransactionTypeDetailsRoute from './transaction-types/TransactionTypeDetailsRoute';
import TransactionTypeCreateRoute from './transaction-types/TransactionTypeCreateRoute';
const DataProductsRoute = lazy(() => import('./data-products/DataProductsRoute'));
const CreateDataProductRoute = lazy(() => import('./data-products/CreateDataProductRoute'));
const DataProductRoute = lazy(() => import('./data-products/DataProductRoute'));

export default [
  <Route
    key="charts-of-accounts"
    path="/charts-of-accounts"
    element={
      <RequireAuth {...routeAccess.admin}>
        <ChartsOfAccountsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="charts-of-accounts-new"
    path="/charts-of-accounts/new"
    element={
      <RequireAuth {...routeAccess.adminCreateRestricted}>
        <ChartOfAccountsCreateRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="charts-of-accounts-details"
    path="/charts-of-accounts/:id"
    element={
      <RequireAuth {...routeAccess.admin}>
        <ChartOfAccountsDetailsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="accounting-months"
    path="/accounting-months"
    element={
      <RequireAuth {...routeAccess.admin}>
        <AccountingMonthsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="accounting-months-new"
    path="/accounting-months/new"
    element={
      <RequireAuth {...routeAccess.adminCreate}>
        <AccountingMonthCreateRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="accounting-months-details"
    path="/accounting-months/:id"
    element={
      <RequireAuth {...routeAccess.admin}>
        <AccountingMonthDetailsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="operating-messages"
    path="/operating-messages"
    element={
      <RequireAuth {...routeAccess.admin}>
        <OperatingMessagesRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="operating-messages-details"
    path="/operating-messages/:id"
    element={
      <RequireAuth {...routeAccess.admin}>
        <OperatingMessageDetailsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="operating-messages-new"
    path="/operating-messages/new"
    element={
      <RequireAuth {...routeAccess.adminCreate}>
        <OperatingMessageCreateRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="audit-log"
    path="/audit-log"
    element={
      <RequireAuth {...routeAccess.admin}>
        <AuditLogsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="audit-log-details"
    path="/audit-log/:id"
    element={
      <RequireAuth {...routeAccess.admin}>
        <AuditLogRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="manual-refs"
    path="/manual-refs"
    element={
      <RequireAuth {...routeAccess.admin}>
        <RefererRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="manual-refs-new"
    path="/manual-refs/new"
    element={
      <RequireAuth {...routeAccess.adminCreate}>
        <CreateRefRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="manual-refs-details"
    path="/manual-refs/:id"
    element={
      <RequireAuth {...routeAccess.admin}>
        <RefRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="partners"
    path="partners"
    element={
      <RequireAuth {...routeAccess.admin}>
        <PartnersRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="partners-new"
    path="partners/new"
    element={
      <RequireAuth {...routeAccess.adminCreateRestricted}>
        <PartnerCreateRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="partners-details"
    path="partners/:id"
    element={
      <RequireAuth {...routeAccess.admin}>
        <PartnerRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="transaction-types"
    path="transaction-types"
    element={
      <RequireAuth {...routeAccess.admin}>
        <TransactionTypesRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="transaction-types-new"
    path="transaction-types/new"
    element={
      <RequireAuth {...routeAccess.adminCreateRestricted}>
        <TransactionTypeCreateRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="transaction-types-details"
    path="transaction-types/:id"
    element={
      <RequireAuth {...routeAccess.admin}>
        <TransactionTypeDetailsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="data-products"
    path="/data-products"
    element={
      <RequireAuth {...routeAccess.admin}>
        <DataProductsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="data-products-new"
    path="/data-products/new"
    element={
      <RequireAuth {...routeAccess.adminCreateRestricted}>
        <CreateDataProductRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="data-product"
    path="/data-products/:id"
    element={
      <RequireAuth {...routeAccess.admin}>
        <DataProductRoute />
      </RequireAuth>
    }
  />,
];
